/** Fired after `loggedInUser` in localStorage is updated so UI can re-read it. */
export const LOGGED_IN_USER_UPDATED = "loggedInUserUpdated";
